export default __webpack_public_path__ + "static/sakhalin-c10a95cefd8b780a6749bb73eb8a8fa8.jpg";